export default "../fonts/ab-manager-negative.svg";